import { request } from '@@/exports';

// 话术
export async function getCommonPhrases() {
  return request<API.Response>(`/chat-phrase`);
}

// 话术保存
export async function storeCommonPhrases(data: FORM.CommonPhrasesForm) {
  return request<API.Response>(`/chat-phrase/save`, {
    method: 'POST',
    data,
  });
}

// 咨询设置
export async function getConsultationConfigs() {
  return request<API.Response>(`/customer-admin-consults`);
}

// 保存设置
export async function storeConsultationConfig(data: FORM.ConsultationConfigForm) {
  return request<API.Response>(`/customer-admin-consults`, {
    method: 'POST',
    data: { data },
  });
}

